import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientStateService } from './logic/client-state.service';
import { GeneralClientStateService } from './logic/general-client-state/general-client-state.service';
import { ClientStateStorageDaoService } from './dao/client-state-storage-dao/client-state-storage-dao.service';
import { ClientStateDaoService } from './dao/client-state-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ClientStateService, useClass: GeneralClientStateService },
    { provide: ClientStateDaoService, useClass: ClientStateStorageDaoService }
  ]
})
export class ClientStateModule {}
